var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"card p-2 mb-2"},[_c('label',[_vm._v("Symbols")]),_c('b-table',{attrs:{"items":_vm.symbol,"fields":_vm.fields,"responsive":"","show-empty":""}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }